// Desc: Authentication hook

import { useQuery } from '@tanstack/react-query';

import secureLocalStorage from 'react-secure-storage';
import { fetchProfile } from '@/api/authApi';

const useAuthentication = () => {
  const authenticated = secureLocalStorage.getItem('auth');

  const user = useQuery({
    queryKey: ['user'],
    queryFn: fetchProfile,
    enabled: !!authenticated,
    onSuccess: (data) => {}
  });

  return { user: user?.data?.data, authenticated };
};

export default useAuthentication;
